import { render, staticRenderFns } from "./ProjectNameTableCell.vue?vue&type=template&id=24c2ac69&scoped=true"
import script from "./ProjectNameTableCell.vue?vue&type=script&lang=js"
export * from "./ProjectNameTableCell.vue?vue&type=script&lang=js"
import style0 from "./ProjectNameTableCell.vue?vue&type=style&index=0&id=24c2ac69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c2ac69",
  null
  
)

export default component.exports